module.exports = __webpack_public_path__ + "fonts/FreightNeoProSemi-Italic.7780ee17.otf";